interface AverageRateCardProps {
  title: string;
  rate: number | string;
}

export default function AverageRateCard({ title, rate }: AverageRateCardProps) {
  return (
    <div className="averageRate">
      <div className="avgTitle">{title}</div>
      <div className="avgRate">
        ${rate !== 0 ? rate : <span style={{ color: "#6454F4" }}>...</span>} /
        hr
      </div>
    </div>
  );
}
